import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import StatsBar from './components/StatsBar';
import Features from './components/Features';
import Scenarios from './components/Scenarios';
import Reviews from './components/Reviews';
import CTA from './components/CTA';

export default function Home() {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'mrds',
      url: 'https://mrds.io',
      description: 'mrds 是您值得信赖的专业平台，提供智能数据处理、自动化工作流和实时协作等一站式解决方案。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-MRDS',
        contactType: 'customer service',
        availableLanguage: 'Chinese',
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Beijing',
        addressCountry: 'CN',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'mrds 官方平台',
      url: 'https://mrds.io',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://mrds.io/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'mrds 官方平台首页',
      description: 'mrds 是您值得信赖的专业平台，全面介绍 mrds 的核心功能、应用场景、使用方法及用户评价。',
      url: 'https://mrds.io',
      isPartOf: {
        '@type': 'WebSite',
        name: 'mrds 官方平台',
        url: 'https://mrds.io',
      },
    },
  ];

  return (
    <>
      <SEOHead
        title="首页"
        description="mrds 是您值得信赖的专业平台，全面介绍 mrds 的核心功能、应用场景、使用方法及用户评价，帮助您快速了解 mrds 的独特价值。"
        keywords="mrds,mrds 功能介绍,mrds 使用教程,mrds 官方平台,mrds 下载,mrds 评测,mrds 应用场景"
        canonicalUrl="https://mrds.io"
        jsonLd={jsonLd}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <Features />
        <Scenarios />
        <Reviews />
        <CTA />
      </main>
      <Footer />
    </>
  );
}